import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import SEOHead from '@/components/marketplace/SEOHead';
import { Button } from '@/components/ui/button';
import { loadRedirects, normalizePath } from '@/lib/redirectStore';

// Catch-all for unknown paths. First consults the admin redirect map — if the
// path is a configured redirect source, it redirects (301/302 semantics via
// replace/push). Otherwise it renders a real 404 (noindex) — it does NOT
// auto-redirect unknown URLs to the homepage (avoids soft-404 SEO harm).
const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState('checking');

  useEffect(() => {
    let cancelled = false;
    loadRedirects().then((map) => {
      if (cancelled) return;
      const hit = map[normalizePath(location.pathname)];
      if (hit) {
        if (/^https?:\/\//.test(hit.destination)) window.location.replace(hit.destination);
        else navigate(hit.destination, { replace: hit.type === 301 });
        return;
      }
      setState('404');
    });
    return () => { cancelled = true; };
  }, [location.pathname, navigate]);

  if (state === 'checking') {
    return <div className='indus-container py-24 text-center text-muted-foreground' data-testid='notfound-checking'>Loading…</div>;
  }

  return (
    <div className='indus-container py-24 text-center' data-testid='notfound-page'>
      <SEOHead title='Page not found (404) | IndusFact' robots='noindex,follow' />
      <div className='text-6xl font-bold tracking-tight text-muted-foreground/40'>404</div>
      <h1 className='mt-4 text-2xl font-semibold'>Page not found</h1>
      <p className='mt-2 text-muted-foreground'>The page you’re looking for doesn’t exist or has moved.</p>
      <div className='mt-6 flex justify-center gap-3'>
        <Button asChild><Link to='/'>Go home</Link></Button>
        <Button variant='outline' asChild><Link to='/categories'>Browse categories</Link></Button>
      </div>
    </div>
  );
};

export default NotFound;
